import * as React from 'react';
import { useDispatch } from 'react-redux';

import { setValuationFiltersModalOpened } from '../../actions/page';
import { trackGoToEstimBtnClick } from '../../analytics';
import { ValuationPrimaryButton } from '../../components/ValuationPrimaryButton';
import { useButtonText } from '../ValuationSubmitContainer';

interface IValuationFormModalOpenerContainerProps {
  className?: string;
  inStickyFooter?: boolean;
  btnOnPageInViewRef?: React.Ref<HTMLButtonElement>;
}

/** Кнопка для открытия модалки с формой оценки */
export const ValuationFormModalOpenerContainer: React.VFC<IValuationFormModalOpenerContainerProps> = ({
  className,
  inStickyFooter,
  btnOnPageInViewRef,
}) => {
  const dispatch = useDispatch();
  const btnText = useButtonText();

  const onClickHandler = React.useCallback(() => {
    trackGoToEstimBtnClick();
    dispatch(setValuationFiltersModalOpened(true));
  }, [dispatch]);

  return (
    <ValuationPrimaryButton
      ref={btnOnPageInViewRef}
      className={className}
      onClick={onClickHandler}
      testId={`open_modal_val_form${inStickyFooter ? '_sticky' : ''}`}
    >
      {btnText}
    </ValuationPrimaryButton>
  );
};
